function isPixel(dimension) {
  return String(dimension).includes('px')
}

export default function (vm) {
  let width, height

  // 判断是否为整数或者后面加px
  if (Number.isInteger(vm.width) || isPixel(vm.width)) {
    width = parseInt(vm.width, 10)
  }
  if (Number.isInteger(vm.height) || isPixel(vm.height)) {
    height = parseInt(vm.height, 10)
  }

  if (isNaN(width) && vm.$el) {
    const styleWidth = window.getComputedStyle(vm.$el).width
    if (isPixel(styleWidth)) {
      width = parseInt(styleWidth, 10)
    }
  }
  if (isNaN(height) && vm.$el) {
    const styleHeight = window.getComputedStyle(vm.$el).height
    if (isPixel(styleHeight)) {
      height = parseInt(styleHeight, 10)
    }
  }

  // TODO 这里假设 auto 没有返回数值,待验证
  if ((isNaN(width) && isNaN(height)) || (!width && !height)) {
    return {}
  }

  // 如果宽高比原始的大, 则需要计算出高度
  const naturalWidth = vm.$el.naturalWidth
  const naturalHeight = vm.$el.naturalHeight

  if (width > naturalWidth) {
    width = naturalWidth
  }
  if (height > naturalHeight) {
    height = naturalHeight
  }

  // getComputedStyle 有可能会返回 natural[Width/Height],这使得其返回值不可直接使用,还需要最后 resize 一下。
  // const scaleWidth = (height * vm.$el.naturalWidth) / vm.$el.naturalHeight
  // const scaleHeight = (width * vm.$el.naturalHeight) / vm.$el.naturalWidth
  const scaleWidth = width
  const scaleHeight = height

  if (!scaleWidth || width * scaleHeight <= height * scaleWidth) {
    return { width, height }
  } else if (!scaleHeight || scaleWidth * height <= scaleHeight * width) {
    return { width, height }
  }
  return {}
}
